import { PlatformAppsApiClient } from '@fourthwall/services/dist/PlatformAppsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'
import { useQueryClient } from '@tanstack/react-query'

const useUpdatePlatformAppClientIconMutation = createMutationHook(
  PlatformAppsApiClient.updatePlatformAppClientIcon,
  {
    mutationKey: ['updatePlatformAppClientIcon'],
  },
)

export const useUpdatePlatformAppClientIcon = () => {
  const queryClient = useQueryClient()
  const { updatePlatformAppClientIconMutation } = useUpdatePlatformAppClientIconMutation({
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['platformAppClients'] })
      await queryClient.invalidateQueries({ queryKey: ['platformAppClient'] })
    },
  })

  return {
    updatePlatformAppClientIcon: updatePlatformAppClientIconMutation.mutate,
    isLoading: updatePlatformAppClientIconMutation.isLoading,
  }
}
